import Script, { ScriptProps } from 'next/script';

export const WishCloudScript: React.FC = (props: Omit<ScriptProps, 'src'>) => (
    <>
        <link
            rel="stylesheet"
            href="https://storage.googleapis.com/gowish-button-prod/css/gowish-iframe.css"
        />

        <Script
            id="gowish-iframescript"
            type="application/javascript"
            strategy="lazyOnload"
            data-region="denmark"
            {...props}
            src="https://storage.googleapis.com/gowish-button-prod/js/gowish-iframe.js"
        />
    </>
);
